import referal_video from "./file.mp4";
import video_banner from "./video_banner.mp4";

export { referal_video, video_banner };
